import CostBreakdown from "components/Simulation/CostBreakdown";
import { useGameContext } from "GameContext";
import GridDiv from "components/Map/GridDiv";

import {
  useMemo,
  useState,
} from "react";

import {
  type GameState,
} from "utils/game_utils"

export default function SimulationResult({
  mapActions,
  muActions,
  simResults,
  waterRegime,
  agCost,
  closeWindow,
  faunaActions={},
}: {
  faunaActions?: Record<string, any>,
  mapActions?: Record<string, any>,
  muActions?: Record<string, any>,
  simResults: GameState,
  waterRegime?: number,
  agCost?: any,
  closeWindow?: () => void,
}) {
  const {
    currentYear,
    playerInfo,
    currentGameState,
    roleGroups,
  } = useGameContext() as any;

  const roleGroup = roleGroups[`${playerInfo.estate}-${playerInfo.role}`]
  const startingRoleMoney = roleGroup?.money ?? 0

  const cellData = simResults?.cellData
  const simData = simResults?.simData


  const seasons = ['Sp', 'Su', 'F', 'W']
  const [currentSeason, setCurrentSeason] = useState(1);

  const [currentTab, setCurrentTab] = useState(0);

  return (
    <div className="h-full w-full border-2 border-black bg-[#BCB7A8] p-2 flex flex-col overflow-y-auto">
      <button className="absolute right-0 top-0 h-8 w-8" onClick={closeWindow}>x</button>
      <div className="flex flex-row pb-2">
        <div className="border-b border-black w-2"/>
        <button
          className={`${currentTab === 0 ? "bg-opacity-0" : "border-b bg-opacity-10"} bg-black border-t border-x border-black px-4 py-1`}
          onClick={()=>setCurrentTab(0)}
        >Config</button>

        <div className="border-b border-black w-2"/>

        <button
          className={`${currentTab === 1 ? "bg-opacity-0" : "border-b bg-opacity-10"} bg-black border-t border-x border-black px-4 py-1`}
          onClick={()=>setCurrentTab(1)}
        >Cost</button>
        <div className="border-b border-black w-2"/>
        <button
          className={`${currentTab === 2 ? "bg-opacity-0" : "border-b bg-opacity-10"} bg-black border-t border-x border-black px-4 py-1`}
          onClick={()=>setCurrentTab(2)}
        >Results</button>
        <div className="border-b border-black w-full"/>
      </div>

      { currentTab === 0 ? (
        <div className="flex flex-col h-full">
          <label>Selected Water Regime: {waterRegime}</label>
          <div className="flex flex-col grow">
            <label>Proposed Actions</label>
            <div className="grow flex h-full overflow-hidden justify-center">
              <GridDiv
                cellData={currentGameState?.cellData}
                gameState={currentGameState}
                view={"land"}
                currentYear={currentYear}
                mapActions={mapActions}
                faunaActions={faunaActions}
                muActions={muActions}
                showLeft={playerInfo?.estate === "private" || playerInfo?.role === "Conservationist"}
                showRight={playerInfo?.estate === "public"}
                showFauna={playerInfo?.role === "Hunter"}
              />
            </div>
          </div>
        </div>
      ) : currentTab === 1 ? (
        <CostBreakdown
          agCost={agCost}
          startingRoleMoney={startingRoleMoney}
        />
      ) : (
        <div className="flex flex-col h-full">
          <h1>Results of Simulation</h1>
          
          <div className="flex flex-row gap-2 grow">
            <div className="flex flex-col grow">
              <label>Land Types</label>
              <div className="grow flex h-full overflow-hidden justify-center">
                <GridDiv
                  cellData={cellData}
                  muActions={muActions}
                  view={"land"}

                  showAnimals={playerInfo?.role === "Conservationist"}
                  showDucksOnly={playerInfo?.role === "Hunter"}

                  gameState={simResults}

                  currentYear={currentYear+1}
                  selectedWM={waterRegime}
                  showLeft={playerInfo?.estate === "private" || playerInfo?.role === "Conservationist"}
                  currentSeason={currentSeason}
                  showRight={playerInfo?.estate === "public"}
                />
              </div>
            </div>
            <div className="flex flex-col grow">
              <div className="flex flex-row justify-between items-center">
                <label>Water</label>
                <div className="flex flex-row gap-2">
                  {seasons.map((s, i) => (
                    <button onClick={() => setCurrentSeason(i+1)} className={`bg-black ${currentSeason-1===i ? "bg-opacity-10" : "bg-opacity-0"} w-6 h-6 rounded-full`} key={i}>{s}</button>
                  ))}
                </div>
              </div>


              <div className="grow flex h-full overflow-hidden justify-center">
                <GridDiv
                  cellData={cellData}
                  view={"water"}
                  currentYear={currentYear+1}
                  currentSeason={currentSeason}
                  showLeft={playerInfo?.estate === "private" || playerInfo?.role === "Conservationist"}
                  showRight={playerInfo?.estate === "public"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
